export default function Footer() {
  const solutions = [
    "全渠道智能客服",
    "获客机器人",
    "企业微信智能客服",
    "电商商家智能客服",
    "美团商家智能客服",
    "内容平台私信智能回复",
    "内容平台评论智能回复",
  ];

  return (
    <footer className="bg-gradient-to-br from-[#f0f7ff] to-[#e8f4fc] py-8 sm:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row items-start justify-between gap-6 sm:gap-8 mb-6 sm:mb-8">
          <div className="w-full md:w-auto md:max-w-[200px]">
            <a href="/index.html" className="flex items-center gap-2 mb-3">
              <img
                src="https://osscdn.fhd001.com/fhdportal/typimg/81e6b43043304376a2a1faf863540a1d.png"
                alt="火花派智能客服"
                className="w-7 h-7 sm:w-8 sm:h-8 object-contain"
              />
              <span className="text-base sm:text-lg font-bold text-gray-900">
                火花派智能客服
              </span>
            </a>
            <p className="text-xs sm:text-sm text-gray-500 leading-relaxed">
              以智能降本增效，
              <br />
              让企业的每一分投入都有回报
            </p>
          </div>

          {/* 解决方案 */}
          <div className="w-full md:w-auto">
            <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4">
              解决方案
            </h4>
            <ul className="space-y-2 sm:space-y-2.5">
              {solutions.map((item) => (
                <li key={item}>
                  <span className="text-xs sm:text-sm text-gray-600">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系我们 */}
          <div className="w-full md:w-auto">
            <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4">
              <a
                href="#contact"
                className="hover:text-[#FF6B35] transition-colors"
              >
                联系我们
              </a>
            </h4>
            <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6">
              {/* 左侧：联系信息 */}
              <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm text-gray-600 w-full sm:w-auto">
                <li className="flex items-center gap-2">
                  <span className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                    <i className="ri-phone-line text-[#FF6B35]"></i>
                  </span>
                  <span>0571-28076571转7号键</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-[#FF6B35]"></i>
                  </span>
                  <span>wanghao@rantron.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                    <i className="ri-map-pin-line text-[#FF6B35]"></i>
                  </span>
                  <span>杭州市滨江区聚光中心</span>
                </li>
              </ul>

              {/* 右侧：二维码 */}
              <div className="bg-white rounded-lg p-2.5 sm:p-3 border border-gray-100 mx-auto sm:mx-0">
                <img
                  src="https://static.readdy.ai/image/c9656b810d2c6cc0a8672cac16e7cf96/e7f95b852e2d7fc033ed8e2278921757.png"
                  alt="联系人二维码"
                  className="w-20 h-20 sm:w-24 sm:h-24 rounded"
                />
                <p className="text-[10px] sm:text-xs text-gray-500 text-center mt-1.5 sm:mt-2">
                  扫码详细咨询
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-4 sm:pt-6 flex flex-col items-center gap-3 sm:gap-4">
          <div className="text-xs sm:text-sm text-gray-500 text-center">
            @2026 杭州树果未来科技有限公司 版权所有
          </div>
          <div className="text-xs sm:text-sm text-gray-500 text-center flex items-center justify-center gap-1.5 whitespace-nowrap">
            <img
              src="https://img1.fhd001.com/saas/osd/login/record-icon.png"
              alt=""
              className="icon-img record-icon"
            />
            浙公网安备33010602003169号
            <span className=" _margin-l-1">浙ICP备13005746号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
